
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { ProcurementFormValues } from "../../schema";

interface VatToggleProps {
  form: UseFormReturn<ProcurementFormValues>;
}

export const VatToggle = ({ form }: VatToggleProps) => {
  return (
    <FormField
      control={form.control}
      name="vat_applicable"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">VAT Applicable</FormLabel>
            <FormDescription>
              Toggle if VAT is applicable to this procurement
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
